export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const HAS_LOWER_CASE_CHARACTER_REGEX = /[a-z]/
export const HAS_UPPER_CASE_CHARACTER = /[A-Z]/
export const SLACK_CHANNEL_LINK_REGEX =
  /^(http(s?):\/\/)?(www\.)?[a-zA-Z0-9_.-]+.slack.com\/archives\/[a-zA-Z0-9_.-]+\/?$/
export const GITHUB_LINK_REGEX = /^(https?:\/\/)?(www\.)?github\.com\/[a-zA-Z0-9_-]{1,25}$/gim
export const LINKEDIN_LINK_REGEX =
  /(https?:\/\/(www.)|(www.))?linkedin.com\/(mwlite\/|m\/)?in\/[a-zA-Z0-9_.-]+\/?/
export const URL_REGEX =
  /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi
export const DATE_REGEX = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/
export const MONTH_YEAR_DATE_REGEX = /^(0[1-9]|1[0-2])\/(19|20)\d{2}$/
export const HOURS_AND_MINUTES_REGEX = /([0-9]+(.[0-9]+)*[mMhH] *)+$/
export const BRAZILIAN_CEP_REGEX = /^\d{5}(-\d{3})?$/
export const CNPJ_REGEX = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/
export const REMOVE_DOUBLE_SPACE_REGEX = /\s\s+/g
export const REMOVE_TIME_REGEX = /T.*$/
